module.exports = __webpack_public_path__ + "nunito-sans-latin-200.0aa9029aa5c94ee0245428787ff2aa8b.woff";